import React from 'react';
import {
  Box, IconButton,
} from '@mui/material';
import { observer } from 'mobx-react';
import { DiscountsStore } from '@gamiphy/loyalty-station-desktop/store/discounts';

import Close from '@mui/icons-material/Close';
import { CashbackPopupsStore } from '@gamiphy/loyalty-station-desktop/store/cashbackPopups';
import { ApplicableDiscountDiscountTypeEnum } from '@coretava/api/ecommerce-service';
import DoNotShowAgain from '../../components/DoNotShowAgain';
import FreeShippingDiscount from './FreeShippingDiscount';
import FreeSkuDiscount from './FreeSkuDiscount';
import Discount from './Discount';

const Verified: React.FC = () => {
  const discountApplicable = React.useMemo(() => !!DiscountsStore.bestFitDiscount?.applicableDiscount.discount && (DiscountsStore.bestFitDiscount?.applicableDiscount.amount ?? 0) > 0, [DiscountsStore.bestFitDiscount]);

  const content = React.useMemo(() => {
    switch (true) {
      case discountApplicable && DiscountsStore.bestFitDiscount?.applicableDiscount.discount?.type === ApplicableDiscountDiscountTypeEnum.FreeShipping:
        return <FreeShippingDiscount discount={DiscountsStore.bestFitDiscount?.applicableDiscount.discount} />;
      case discountApplicable && DiscountsStore.bestFitDiscount?.applicableDiscount.discount?.type === ApplicableDiscountDiscountTypeEnum.FreeSku:
        return <FreeSkuDiscount discount={DiscountsStore.bestFitDiscount?.applicableDiscount.discount} />;
      default:
        return <Discount discountApplicable={discountApplicable} bestFitDiscount={DiscountsStore.bestFitDiscount} />;
    }
  }, [discountApplicable, DiscountsStore.bestFitDiscount]);

  return (
    <Box p={2} maxWidth={350}>
      <Box pb="1.6rem" display="flex" justifyContent="flex-end">
        <IconButton
          sx={{
            ml: 'auto',
            p: 0,
          }}
          disableRipple
          onClick={() => CashbackPopupsStore.closeCashbackPopup()}
        >
          <Close fontSize="large" />
        </IconButton>
      </Box>
      {content}
      <Box mt={1.5}>
        <DoNotShowAgain />
      </Box>
    </Box>
  );
};

export default observer(Verified);
